<div class="kamishibai-card">
  <div class="k-toolbar">
    <div class="d-flex align-items-center gap-2">
      <div class="k-zoom">
        <button
          mat-icon-button
          type="button"
          [disabled]="zoomLevel <= minZoom"
          [attr.aria-label]="'button.zoomOut' | translate"
          [matTooltip]="'button.zoomOut' | translate"
          (click)="zoomOut()"
        >
          <mat-icon>zoom_out</mat-icon>
        </button>
        <span class="k-zoom__level">{{ zoomPercent }}%</span>
        <button
          mat-icon-button
          type="button"
          [disabled]="zoomLevel >= maxZoom"
          [attr.aria-label]="'button.zoomIn' | translate"
          [matTooltip]="'button.zoomIn' | translate"
          (click)="zoomIn()"
        >
          <mat-icon>zoom_in</mat-icon>
        </button>
      </div>
      <ul class="k-legend">
        <li
          class="k-legend__item"
          *ngFor="let entry of legendItems"
          [matTooltip]="entry.hintKey ? (entry.hintKey | translate) : ''"
        >
          <span class="k-legend__swatch" [ngClass]="'k-legend__swatch--' + entry.key">
            <mat-icon aria-hidden="true">{{ entry.icon }}</mat-icon>
          </span>
          <span class="k-legend__label">{{ entry.labelKey | translate }}</span>
        </li>
      </ul>
    </div>

    <app-items-view-controls></app-items-view-controls>
  </div>

  <div class="kamishibai-board">
    <table mat-table [dataSource]="dataSource" class="kamishibai-table" [style.zoom]="zoomLevel">
      <!-- Group Column -->
      <ng-container matColumnDef="group">
        <th mat-header-cell *matHeaderCellDef class="group-header">
          <div class="month-navigation" *ngIf="monthText">
            <button
              mat-icon-button
              type="button"
              [attr.aria-label]="'button.previous' | translate"
              [matTooltip]="'button.previous' | translate"
              (click)="shiftDateRange('backward')"
            >
              <mat-icon>chevron_left</mat-icon>
            </button>
            <span class="month-text">{{ monthText }}</span>
            <button
              mat-icon-button
              type="button"
              [attr.aria-label]="'button.next' | translate"
              [matTooltip]="'button.next' | translate"
              (click)="shiftDateRange('forward')"
            >
              <mat-icon>chevron_right</mat-icon>
            </button>
          </div>
        </th>
        <td
          mat-cell
          *matCellDef="let element"
          [attr.rowspan]="element.rowSpan"
          [style.display]="element.rowSpan ? '' : 'none'"
          [class.is-empty]="!element.groupCount"
          class="group-cell"
        >
          <span class="group-cell__label">
            <span class="group-cell__text">{{ 'system.label.dateRanges.' + element.group | translate }}</span>
            <span class="group-cell__count">{{ element.groupCount }}</span>
          </span>
        </td>
      </ng-container>

      <!-- Dynamic Date Columns -->
      <ng-container *ngFor="let column of dateColumns" [matColumnDef]="column.date">
        <th
          mat-header-cell
          *matHeaderCellDef
          class="date-header"
          [class.is-today]="column.isToday"
          [class.is-weekend]="column.isWeekend"
        >
          <div class="day-pill">
            <span class="day-pill__number">{{ column.dayNumber }}</span>
            <span class="day-pill__weekday">{{ column.weekdayLabel }}</span>
          </div>
        </th>
        <td
          mat-cell
          *matCellDef="let element"
          class="date-cell"
          [class.is-today]="column.isToday"
          [class.is-weekend]="column.isWeekend"
        >
          <app-kamishibai-card
            *ngIf="element[column.date]"
            [item]="element[column.date]"
            [isSimpleMode]="isSimpleCardMode"
            (refreshDashboard)="refreshDashboard()"
          ></app-kamishibai-card>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
    </table>
  </div>
</div>
